import axios from "axios";

export const apiApp = axios.create({
  baseURL: import.meta.env.VITE_APP_BASEURL
});

apiApp.interceptors.request.use(
  async (config: any) => {
    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers['Content-Type'] = 'application/json';

    return config
  },
  (err: any) => {
    Promise.reject(err)
  }
)

apiApp.interceptors.response.use((response) => {
  return response;
}, error => {
  if (error.response?.data?.Message) {
    return Promise.reject(error.response.data.Message)
  } if (error.message === 'Network Error') {
    console.log('Verificar conexão com a API')
    return Promise.reject('Ocorreu um erro de integração - ' + JSON.stringify(error))
  } else if (error.response.status === 403) {
    return Promise.reject('Usuário não possui permissão para ação')
  }

  console.log(error.message);
  return Promise.reject('Ocorreu um erro inesperado')
})